import bankingOperations from './banking-operations';
import crmMails from './crm-mails';
import mailTemplates from './mail-templates';
import mailGroups from './mail-groups';

export default [
  ...bankingOperations,
  ...crmMails,
  ...mailTemplates,
  ...mailGroups
];
